import React from 'react';

/**
 * The long header box under the round strip.
 *
 * `title` is the game's own name (NFL / NBA / MISH MOSH / NAME THAT GUY SR.).
 * It accepts a node so NTG can render its SR./JR. suffix in red. Falls back to
 * the H2H "Player N" label when no title is supplied.
 *
 * `rightLabel` overrides the "Question N / M" counter for single-question
 * games (NTG Sr./Jr. pass "1 Question").
 *
 * `strikes` / `maxStrikes` draw the miss boxes next to the title, reusing the
 * daily's round-dot visual. NTG Sr. passes its used guesses.
 *
 * `correctAt` is the index of the guess that won, turning that box green.
 */
const ScoreBoard = ({
  totalAnswered,
  totalQuestions,
  playerNumber,
  isDailyChallenge,
  title,
  rightLabel,
  strikes,
  maxStrikes = 3,
  correctAt,
  mode,
}) => {
  const dotClass = (i) => {
    if (i === correctAt) return 'correct-dot';
    return i < strikes ? 'wrong-dot' : 'empty-dot';
  };
  return (
    <div className="scoreboard">
      <div className="scoreboard-player">
        <span className="scoreboard-label">
          {title || (isDailyChallenge ? 'Daily Challenge' : `Player ${playerNumber}`)}
        </span>
      </div>
      {typeof strikes === 'number' && (
        <div className="round-dots scoreboard-strikes" title={`${strikes} of ${maxStrikes} guesses used`}>
          {Array.from({ length: maxStrikes }, (_, i) => (
            <span key={i} className={`round-dot ${dotClass(i)}`} />
          ))}
        </div>
      )}
      <div className="scoreboard-question-count scoreboard-right" style={{ marginLeft: 'auto' }}>
        {mode && <span className="scoreboard-mode-tag">{mode}</span>}
        <span style={{ color: '#aaa', fontSize: '0.9rem' }}>
          {rightLabel || `Question ${totalAnswered + 1} / ${totalQuestions}`}
        </span>
      </div>
    </div>
  );
};

export default ScoreBoard;
